export default "__VITE_ASSET__ibvG9ieK__"